const Loader = (headerHeight = '250', color) => {
  const loaderStyle = headerHeight ? 'net-updating' : 'net-updating-small'
    return `<div class='net-main-loader-wrapper'>
    <style>
        @keyframes fade-in-down {
          from {
              opacity:0;
              transform: translatey(10px);
          }
          to {
              opacity:1;
              transform: translatey(0);
          }
      }
  
      @keyframes fade-out {
        from {
            opacity:1;
            transform: translatey(10px);
        }
        to {
            opacity:0;
            transform: translatey(0);
        }
      }
  
      .net-main-loader-wrapper{
        height: 100%;
        border-radius: 10px;
        background: #fff;
        margin: 0 5px 20px;
        box-shadow: 0 1px 5px rgb(0 0 0 / 30%);
        overflow: hidden;
        font-family: 'proxima-nova', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #000000;
      }
      .net-loader-add {
        animation-name: fade-in-down;
        animation-fill-mode: both;
        animation-duration: 1.0s;
      }
      .net-loader-remove {
        animation-name: fade-out;
        animation-fill-mode: both;
        animation-duration: 1.0s;
      }
  
    .net-removed {
        opacity: 0;
    }
      .net-loading-wrapper{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height:100%;
        flex-direction: column;
      }
      .net-updating{
        margin-top:10px;
      }
      div.net-updating-small{
        font-size: 9px;
        margin-top: 0px;
      }
    </style>
    <div class="net-loading-wrapper net-loader-add">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <circle cx="50" cy="50" fill="none" stroke="${color}" stroke-width="8" r="40" stroke-dasharray="160.22122533307947 55.40707511102649">
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.9615384615384615s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
      </circle>
      </svg>
      <div class=${loaderStyle}>Updating...</div>
    </div>
  </div>`
}

export default Loader